import(/* webpackMode: "eager" */ "/app/src/app/[commerce]/[locale]/[currency]/(root)/error.tsx");
